import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import { isAndroid, isIOS } from "react-device-detect";
import images from "../../assets";
import * as S from "./AppBanner.styles";

interface IProps {}

class AppBanner extends React.Component<IProps> {
  // Render
  public render() {
    return (
      <S.Wrap>
        <S.ButtonWrap onClick={this.handlePressOpenApp}>
          <S.InnerWrap>
            <S.AppIcon src={images.ICO_PHONE} />
            <S.TextWrap>
              <S.Title>{getLocalizedText("app_banner.title")}</S.Title>
              <S.Subtitle>{this.getSubtitle()}</S.Subtitle>
            </S.TextWrap>
            <S.OpenAppButton onClick={this.handlePressOpenApp}>
              <S.OpenAppButtonText>
                {this.getOpenAppButtonText()}
              </S.OpenAppButtonText>
            </S.OpenAppButton>
          </S.InnerWrap>
        </S.ButtonWrap>
      </S.Wrap>
    );
  }

  // Event handlers
  private handlePressOpenApp = async () => {
    const url = "https://rentio.page.link/install-the-app";
    window.open(url, "_blank");
  };

  // Helpers
  private getSubtitle = () => {
    if (isIOS || isAndroid) {
      return getLocalizedText("app_banner.subtitle.mobile");
    }

    return getLocalizedText("app_banner.subtitle.desktop");
  };

  private getOpenAppButtonText = () => {
    if (isIOS || isAndroid) {
      // "Open"
      return getLocalizedText("app_banner.cta.open_app.mobile");
    }

    // "Install"
    return getLocalizedText("app_banner.cta.open_app.desktop");
  };
}

export default AppBanner;
